module.exports = "/images/vendor/flag-icon-css/flags/1x1/mn.svg?933606d511566e3f0d15be1b7aa45a76";